import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Carousel as CarouselDiv, H1 } from '@sitebase/ui-kit';
import './pageTitle.scss';
import { BUILD_YOUR_ODDS, COUPONS, DAILY_LIST } from '../../../generateBreadcrumb/constants';
import { arrayNavigationFootball } from './arrayNavigations';
import slugifier from '@wh/slugifier';
import { withTranslator } from '@wh/ui-translations';

const PageTitle = ({ pageTitle, mobile, locale, t }) => {
    const pageTitleCss = classNames('page-title', {
        'page-title--mobile': mobile,
    });
    const jurisdictionAccept = ['es-es', 'it-it'];
    const visibleForSport = ['football', 'fútbol', 'calcio'];
    const visibleOnPage = [DAILY_LIST, COUPONS, BUILD_YOUR_ODDS];
    const [path, setPath] = useState('');

    useEffect(() => {
        setPath(decodeURIComponent(window.location.pathname));
    }, []);

    const type = () => {
        if (
            (path?.includes(t('path')('byo')) || path?.includes('build-your-odds')) &&
            path?.includes(t('path')('matches'))
        ) {
            return BUILD_YOUR_ODDS;
        } else if (path?.includes(t('path')('matches'))) {
            return DAILY_LIST;
        } else if (path?.includes(t('path')('coupons'))) {
            return COUPONS;
        }
        return undefined;
    };
    const filterData = arrayNavigationFootball.filter((val) => val.type === type() && val.lng === locale);
    const navItems = filterData.flatMap((v) => v.nav);

    const pathBuilider = (page) => {
        return locale && page === BUILD_YOUR_ODDS
            ? `/betting/${locale}/${t('common')('football')}/${t('common')('matches').toLowerCase()}/${t('common')(
                  'competition'
              ).toLowerCase()}/${t('common')('today').toLowerCase()}/${slugifier(page)}`
            : page
            ? `/betting/${locale}/${t('common')('football')}/${slugifier(page)}`
            : `/betting/${locale}/${t('common')('football')}`;
    };

    const navigateTo = (e, page) => {
        e.preventDefault();
        if (page === 'byo-hub' || page === 'partidos') {
            window.location.href = page;
        } else window.location.href = pathBuilider(page);
    };

    return (
        <div styleName={pageTitleCss}>
            <H1>{pageTitle}</H1>
            {mobile &&
                visibleForSport.some((v) => path.includes(v)) &&
                jurisdictionAccept.includes(locale) &&
                visibleOnPage.includes(type()) && (
                    <CarouselDiv styleName={classNames('carousel')} data-theme="light" activeElement={-1}>
                        {navItems.map(({ name, page }, index) => (
                            <a
                                key={`pageTitle-${name}-${index}`}
                                href={pathBuilider(page)}
                                onClick={(e) => navigateTo(e, page)}
                                className="non-route"
                                data-test-id={`${name}`}
                                styleName="nav"
                            >
                                {name}
                            </a>
                        ))}
                    </CarouselDiv>
                )}
        </div>
    );
};

export const pageTitlePropTypes = PropTypes.string;

PageTitle.propTypes = {
    pageTitle: pageTitlePropTypes,
    mobile: PropTypes.bool.isRequired,
    locale: PropTypes.string,
    t: PropTypes.func.isRequired,
};

export default withTranslator(PageTitle);
